import React from "react";
import { Space, Table, Tag } from "antd";
import { Link } from "react-router-dom";

const columns = [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "Nội dung",
    dataIndex: "content",
    key: "content",
  },
  {
    title: "Ngày gửi",
    dataIndex: "date",
    key: "date",
  },
  {
    title: "Người gửi",
    dataIndex: "sender",
    key: "sender",
  },
  {
    title: "Áp dụng với",
    dataIndex: "appliedTo",
    key: "appliedTo",
  },
  {
    title: "Loại báo cáo",
    dataIndex: "reportType",
    key: "reportType",
    render: (text) => <Tag color="blue">{text}</Tag>,
  },
  {
    title: "Tình trạng",
    dataIndex: "status",
    key: "status",
    render: (status) => {
      let color = status === "Đã xử lý" ? "green" : "volcano";
      return <Tag color={color}>{status}</Tag>;
    },
  },
  {
    title: "Hành động",
    key: "action",
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/censor/report/${record.id}`}>Xem chi tiết</Link>
        <a>Xóa</a>
      </Space>
    ),
  },
];

const data = [
  {
    key: "1",
    id: "R001",
    content: "Nội dung vi phạm quy tắc cộng đồng.",
    date: "2025-02-17",
    sender: "Nguyễn Văn A",
    appliedTo: "Bài viết #123",
    reportType: "Ngôn từ thù địch",
    status: "Đã xử lý",
  },
  {
    key: "2",
    id: "R002",
    content: "Spam quảng cáo không phù hợp.",
    date: "2025-02-16",
    sender: "Trần Thị B",
    appliedTo: "Bình luận #456",
    reportType: "Spam",
    status: "Đang xem xét",
  },
  {
    key: "3",
    id: "R003",
    content: "Hình ảnh không phù hợp.",
    date: "2025-02-15",
    sender: "Lê Văn C",
    appliedTo: "Bài viết #789",
    reportType: "Nội dung nhạy cảm",
    status: "Đã xử lý",
  },
];

const ModerationsLog = () => {
  return (
    <div>
      <h2>Tổng hợp báo cáo</h2>
      <Table columns={columns} dataSource={data} />
    </div>
  );
};

export default ModerationsLog;
